module.exports = __webpack_public_path__ + "static/media/BrandonDavid_Resume.2b82d137.pdf";